import React, { useState } from 'react';
import { apiClient } from '../../../api/apiClient';
import FlightModal from './FlightModal';
import {
  mobileActionRow,
  mobileAddButton,
  mobileAmount,
  mobileCard,
  mobileCardHeader,
  mobileCardList,
  mobileCardTitle,
  mobileDeleteButton,
  mobileEditButton,
  mobileEmpty,
  mobileInfoGrid,
  mobileInfoItem,
  mobileInfoLabel,
  mobileInfoValue,
  mobileSubText,
  mobileTabWrap,
  mobileTitleText,
  mobileTopActionRow,
} from './ReservationDetail.mobileStyles';

const fmt = (n) => (n == null ? '-' : Number(n).toLocaleString('ko-KR'));
const fmtDt = (d, raw) => {
  if (d) return String(d).replace('T', ' ').slice(0, 16);
  if (raw) return `(원본) ${raw}`;
  return '-';
};
const TYPE_KR = { adult: '성인', child: '소아', infant: '유아' };

export default function FlightsTab({ rows = [], travelCode, onChanged, isMobile = false }) {
  const [modalRow, setModalRow] = useState(undefined);

  async function handleDelete(row) {
    if (!window.confirm(`항공편 #${row.id} 삭제하시겠습니까?`)) return;
    const r = await apiClient.delete(`/api/admin/flight-bookings/${row.id}`);
    if (r.ok && r.data?.success) onChanged && onChanged();
    else alert(r.data?.message || '삭제 실패');
  }

  return (
    <div style={isMobile ? mobileTabWrap : { display: 'grid', gap: 8 }}>
      <div style={isMobile ? mobileTopActionRow : { display: 'flex', justifyContent: 'flex-end' }}>
        <button onClick={() => setModalRow(null)} style={isMobile ? mobileAddButton : addBtn}>+ 항공편 추가</button>
      </div>
      {rows.length === 0 ? (
        <div style={isMobile ? mobileEmpty : emptyStyle}>항공편 없음</div>
      ) : isMobile ? (
        <div style={mobileCardList}>
          {rows.map((r, index) => (
            <div key={r.id} style={mobileCard}>
              <div style={mobileCardHeader}>
                <div style={mobileCardTitle}>
                  <span style={mobileTitleText}>항공 #{index + 1} · {TYPE_KR[r.passenger_type] || '-'}</span>
                  <span style={mobileSubText}>{r.passenger_name || r.airline || '-'}</span>
                </div>
                <span style={mobileAmount()}>{fmt(r.total_payment)}</span>
              </div>
              <div style={mobileInfoGrid}>
                <Info label="여정" value={`${r.departure_airport || '-'} → ${r.arrival_airport || '-'}`} />
                <Info label="항공/편명" value={`${r.airline || '-'} / ${r.flight_number || '-'}`} />
                <Info label="출발" value={fmtDt(r.departure_at, r.departure_raw)} />
                <Info label="도착" value={fmtDt(r.arrival_at, r.arrival_raw)} />
                <Info label="좌석" value={r.seat_no || '-'} />
                <Info label="탑승자" value={r.passenger_name || '-'} />
              </div>
              <div style={mobileActionRow}>
                <button onClick={() => setModalRow(r)} style={mobileEditButton}>수정</button>
                <button onClick={() => handleDelete(r)} style={mobileDeleteButton}>삭제</button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
            <thead style={{ background: 'var(--bg)', color: 'var(--text-muted)' }}>
              <tr>
                <th style={th}>항공사</th>
                <th style={th}>편명</th>
                <th style={th}>여정</th>
                <th style={th}>출발</th>
                <th style={th}>도착</th>
                <th style={th}>탑승자</th>
                <th style={th}>구분</th>
                <th style={th}>좌석</th>
                <th style={{ ...th, textAlign: 'right' }}>총결제</th>
                <th style={th}></th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} style={{ borderTop: '1px solid var(--border)' }}>
                  <td style={td}>{r.airline || '-'}</td>
                  <td style={td}>{r.flight_number || '-'}</td>
                  <td style={td}>{r.departure_airport || '-'} → {r.arrival_airport || '-'}</td>
                  <td style={td}>{fmtDt(r.departure_at, r.departure_raw)}</td>
                  <td style={td}>{fmtDt(r.arrival_at, r.arrival_raw)}</td>
                  <td style={td}>{r.passenger_name || '-'}</td>
                  <td style={td}>{TYPE_KR[r.passenger_type] || '-'}</td>
                  <td style={td}>{r.seat_no || '-'}</td>
                  <td style={{ ...td, textAlign: 'right', fontWeight: 600 }}>{fmt(r.total_payment)}</td>
                  <td style={{ ...td, whiteSpace: 'nowrap' }}>
                    <button onClick={() => setModalRow(r)} style={editBtn}>수정</button>{' '}
                    <button onClick={() => handleDelete(r)} style={delBtn}>삭제</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {modalRow !== undefined && (
        <FlightModal
          travelCode={travelCode}
          row={modalRow}
          onClose={() => setModalRow(undefined)}
          onSaved={() => onChanged && onChanged()}
        />
      )}
    </div>
  );
}

function Info({ label, value }) {
  return (
    <div style={mobileInfoItem}>
      <span style={mobileInfoLabel}>{label}</span>
      <span style={mobileInfoValue}>{value}</span>
    </div>
  );
}

const th = { padding: '8px 10px', textAlign: 'left', fontWeight: 600, fontSize: 11 };
const td = { padding: '6px 10px', color: 'var(--text)' };
const emptyStyle = { padding: 16, color: 'var(--text-muted)', textAlign: 'center' };
const addBtn = { padding: '4px 12px', background: 'var(--accent-700, #7c3aed)', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 11, fontWeight: 600 };
const editBtn = { padding: '2px 8px', background: 'transparent', color: 'var(--accent-300, #a78bfa)', border: '1px solid var(--accent-700, #7c3aed)', borderRadius: 4, cursor: 'pointer', fontSize: 10 };
const delBtn = { padding: '2px 8px', background: 'transparent', color: '#dc2626', border: '1px solid #dc2626', borderRadius: 4, cursor: 'pointer', fontSize: 10 };
